import React, { useContext, useState } from "react";
import AuthContext from "../store/AuthContext";
import Logo from "../assets/Logo";
import salesagentDotAiLogo from "../assets/salesagentDotAiLogo.png";
import salesagentDotAiLogo1 from "../assets/salesagentDotAiLogo1.png";
import useWindowDimensions from "../hooks/useWindowDimensions";
import PrimaryButton from "./ui/PrimaryButton";
import { useNavigate } from "react-router-dom";
import MenuPopup from "./MenuPopup";
import MobileMenuPopup from "./MobileMenuPopup";

export const Header = () => {
  const { authenticated, logIn, logOut } = useContext(AuthContext);

  const { isMobile, isTab } = useWindowDimensions();

  const navigate = useNavigate();

  const openCalendly = () => {
    const url = "https://calendly.com/fogteams/30min";
    window.open(url, "_blank");
  };

  const [menuScreenOpen, setMenuScreenOpen] = useState(false);

  const menuData = [
    {
      id: 1,
      anchorName: "Industries",
      menuItems: [
        { name: "BFSI", path: "/industries/bfsi" },
        { name: "Automotive", path: "/industries/automotive" },
        // { name: "EdTech", path: "/industries/edtech" },
      ],
    },
    {
      id: 2,
      anchorName: "Use Cases",
      menuItems: [
        { name: "Unlock Hidden Revenue", path: "/use_case/hidden_revenue" },
        {
          name: "Increase Conversion in Sales Lead Qualification",
          path: "/use_case/lead_qualification",
        },
        {
          name: "Physical Visit Scheduling With Address",
          path: "/use_case/scheduling",
        },
        { name: "Cash Collection", path: "/use_case/cash_collection" },
        {
          name: "NPS With Advanced Analytics",
          path: "/use_case/nps",
        },
        { name: "Insurance Renewals", path: "/use_case/renewals" },
      ],
    },
    {
      id: 3,
      anchorName: "Resources",
      menuItems: [
        { name: "Security", path: "/security" },
        { name: "Compliance", path: "/compliance" },
        { name: "Crisis Management", path: "/crisis_management" },
      ],
    },
    // {
    //   id: 4,
    //   anchorName: "Company",
    //   menuItems: [
    //     { name: "About Us", path: "" },
    //     { name: "Careers", path: "" },
    //     { name: "Leadership Team", path: "" },
    //     { name: "Contact Us", path: "" },
    //   ],
    // },
  ];

  const [currentOpenPopup, setCurrentOpenPopup] = useState(null);
  const HEADER_BG_COLOR_CLASS = "bg-[#010021]";

  return (
    <div className="">
      <header
        className={`flex w-full h-24 px-4 sm:px-16 items-center sm:py-9  ${HEADER_BG_COLOR_CLASS} sticky top-0`}>
        <div className="flex font-bold cursor-pointer">
          <img
            onClick={() => {
              setMenuScreenOpen(false);
              navigate("/");
            }}
            className={`w-48 sm:w-60 py-1`}
            src={salesagentDotAiLogo1}
            alt=""
          />
        </div>
        {isTab && (
          <div
            onClick={() => {
              setMenuScreenOpen((prev) => !prev);
            }}
            className="ml-auto cursor-pointer">
            {menuScreenOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="#cdcbff"
                className="w-8 h-8">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="#cdcbff"
                className="w-8 h-8">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            )}
          </div>
        )}
        {!!!isTab && (
          <>
            <div className="grow px-16 flex justify-start items-center gap-8 cursor-pointer z-[50] text-[#fafafc]  text-sm font-medium opacity-[100%]">
              {menuData.map((data) => {
                return (
                  <MenuPopup
                    anchorName={data.anchorName}
                    menuItems={data.menuItems}
                    id={data.id}
                    menuOpen={currentOpenPopup === data.id}
                    setCurrentOpenPopup={setCurrentOpenPopup}
                  />
                );
              })}
            </div>
            <div className="ml-auto flex gap-10">
              <button
                className="text-[#fafafc] opacity-[75%] transition-colors hover:text-white hover:border hover:border-[#CDCBFF] border border-violet-950 font-medium text-sm cursor-pointer rounded-full px-4 py-2"
                onClick={openCalendly}>
                Book Demo
              </button>
              <button
                className="text-[#ffffff] hover:border hover:border-[#CDCBFF] transition-colors border border-violet-950 text-sm font-medium bg-[#33324D] rounded-full px-4 py-2"
                onClick={() => {
                  navigate("/joinwaitlist");
                }}>
                Contact Us
              </button>

              {/*<PrimaryButton
					rounded={true}
					onClick={() => {
						navigate("dashboard/flowchart");
					}}
					text="Dashboard"
				/>
				{authenticated ? (
					<PrimaryButton
						rounded={true}
						onClick={() => {
							logOut();
						}}
						text="Logout">
						Logout
					</PrimaryButton>
				) : (
					<PrimaryButton
						rounded={true}
						onClick={() => {
							navigate("/login");
						}}
						text="Login">
						Login
					</PrimaryButton>
				)}*/}
            </div>
          </>
        )}
      </header>
      {menuScreenOpen && (
        <div
          className={`${HEADER_BG_COLOR_CLASS} h-screen w-screen absolute top-24 z-20 flex flex-col items-center pt-8 gap-8 text-[#fafafc] font-medium`}>
          {menuData.map((data) => {
            return (
              <MobileMenuPopup
                anchorName={data.anchorName}
                menuItems={data.menuItems}
                id={data.id}
                menuOpen={currentOpenPopup === data.id}
                setCurrentOpenPopup={setCurrentOpenPopup}
                setMenuScreenOpen={setMenuScreenOpen}
              />
            );
          })}

          <button
            className="rounded text-[#fafafc] px-4 py-2 rounded-full mr-[2rem] mt-[4rem] opacity-[75%] hover:text-white hover:border hover:border-[#CDCBFF] border border-violet-950"
            onClick={openCalendly}>
            Book Demo
          </button>
          <button
            className="text-[#ffffff] hover:border hover:border-[#CDCBFF] transition-colors border border-violet-950 text-sm font-medium bg-[#33324D] rounded-full mr-[2rem] px-4 py-2"
            onClick={() => {
              setMenuScreenOpen(false);
              navigate("/joinwaitlist");
            }}>
            Contact Us
          </button>
        </div>
      )}
    </div>
  );
};
